import { ElectedInfo } from "../../../../src/components/electeds/elected-info.js";
import Ronen from "../../../../content/people/hillary-ronen/ronen.js";
import * as React from 'react';
export default {
  ElectedInfo,
  Ronen,
  React
};